export default __webpack_public_path__ + "static/bannerbox.tq-cf8f6cf5a8418b7092bbf04de6ceb5c1.jpg";